import { useSEO } from "@/hooks/useSEO";
import profileImage from "@/assets/profile.jpg";
import { Instagram, Youtube } from "lucide-react";
import { BRAND_HANDLE, BRAND_PERSON_NAME } from "@/lib/brandConfig";

const socialLinks = [
  {
    icon: Instagram,
    label: "Instagram",
    href: `https://instagram.com/${BRAND_HANDLE}`,
  },
  {
    icon: Youtube,
    label: "YouTube",
    href: `https://www.youtube.com/@${BRAND_HANDLE}`,
  },
];

const Video = () => {
  useSEO("video");

  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-md mx-auto px-5 py-12 md:py-16">
        <header className="text-center mb-10 animate-fade-in">
          <div className="relative inline-block mb-8">
            <div className="absolute -inset-1 rounded-full bg-gradient-to-br from-border via-muted to-border opacity-60" />
            <div className="relative w-28 h-28 rounded-full overflow-hidden ring-2 ring-background shadow-lg">
              <img
                src={profileImage}
                alt={`${BRAND_PERSON_NAME} - Video content creator profile photo`}
                loading="lazy"
                width={112}
                height={112}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-transparent via-background/10 to-transparent pointer-events-none" />
          </div>

          <h1 className="text-3xl md:text-4xl font-display font-medium text-foreground tracking-wide mb-3 italic">
            Video
          </h1>
          <div className="flex items-center justify-center gap-2 mb-5">
            <span className="w-6 h-px bg-border" />
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-medium">
              Contenido Audiovisual
            </p>
            <span className="w-6 h-px bg-border" />
          </div>
        </header>

        <section
          className="mb-10 animate-fade-in"
          style={{ animationDelay: "0.1s" }}
        >
          <div className="prose prose-sm max-w-none text-muted-foreground space-y-4 text-center">
            <p className="text-sm leading-relaxed">
              Contenido en <strong>video</strong> de {BRAND_PERSON_NAME}. Reels, vlogs,
              tutorials y más en formato audiovisual para Instagram, TikTok y
              YouTube.
            </p>
            <p className="text-sm leading-relaxed">
              Explora mi colección completa de videos y reels.
            </p>
          </div>
        </section>

        <section
          className="mb-10 animate-fade-in"
          style={{ animationDelay: "0.2s" }}
        >
          <div className="flex justify-center gap-6">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-all duration-300"
                aria-label={link.label}
              >
                <link.icon className="w-4 h-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </section>

        <div
          className="text-center animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <a
            href="/fotos"
            className="inline-block text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground transition-colors mb-4"
          >
            Ver Galería de Fotos →
          </a>
        </div>

        <div
          className="text-center animate-fade-in"
          style={{ animationDelay: "0.4s" }}
        >
          <a
            href="/"
            className="inline-block text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground transition-colors"
          >
            ← Volver al inicio
          </a>
        </div>

        <footer
          className="mt-14 text-center animate-fade-in"
          style={{ animationDelay: "0.5s" }}
        >
          <p className="text-[9px] uppercase tracking-[0.2em] text-muted-foreground/60">
            {`@${BRAND_HANDLE}`}
          </p>
        </footer>
      </main>
    </div>
  );
};

export default Video;
